import { DefaultState } from 'store/types';

export const REOPEN_LODGING_REQUEST_REQUEST = 'REOPEN_LODGING_REQUEST_REQUEST';
export const REOPEN_LODGING_REQUEST_SUCCESS = 'REOPEN_LODGING_REQUEST_SUCCESS';
export const REOPEN_LODGING_REQUEST_FAILURE = 'REOPEN_LODGING_REQUEST_FAILURE';

export interface ReopenLodgingRequestData {
  
}

export type ReopenLodgingRequestState = DefaultState & {
  contents?: ReopenLodgingRequestData;
};

interface ReadReopenLodgingRequestDataRequest {
  type: typeof REOPEN_LODGING_REQUEST_REQUEST;
};

interface ReadReopenLodgingRequestDataSuccess {
  type: typeof REOPEN_LODGING_REQUEST_SUCCESS,
  contents: ReopenLodgingRequestData;
}

interface ReadReopenLodgingRequestDataFailure {
  type: typeof REOPEN_LODGING_REQUEST_FAILURE;
}

export type ReopenLodgingRequestActionTypes = ReadReopenLodgingRequestDataRequest | ReadReopenLodgingRequestDataSuccess | ReadReopenLodgingRequestDataFailure;